import { useMutation } from "@apollo/client";
import { LOGOUT } from "graphql/mutations/session";
import { useEffect, useRef, useState } from "react";
import FixedModal from "shared-components/fixed-modal/fixed-modal";

type SessionTimeoutProps = {
  isSessionTimeoutOpen: boolean;
  toggleSessionTimeout: () => void;
};

function SessionTimeout({
  isSessionTimeoutOpen,
  toggleSessionTimeout,
}: SessionTimeoutProps) {
  const [logout, { loading: loadingLogout, data: logoutData }] =
    useMutation(LOGOUT);

  const Ref = useRef<NodeJS.Timer | undefined>(undefined);
  const [timer, setTimer] = useState("00:00");

  const getTimeRemaining = (e: any) => {
    const total = Date.parse(e) - Date.parse(new Date().toLocaleString());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e: any) => {
    let { total, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    } else {
      clearInterval(Ref.current);
      handleLogout();
    }
  };
  const clearTimer = (e: any) => {
    setTimer("02:00");
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };
  const getDeadTime = () => {
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + 120);
    return deadline;
  };

  useEffect(() => {
    clearTimer(getDeadTime());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!loadingLogout && logoutData) {
      localStorage.removeItem("Authorization-Token-Data");
      window.location.reload();
    }
  }, [loadingLogout, logoutData]);

  const handleLogout = () => {
    logout();
  };

  const handleStaySignedIn = () => {
    toggleSessionTimeout();
    clearInterval(Ref.current);
    setTimer("00:00");
  };

  return (
    <FixedModal
      isOpen={isSessionTimeoutOpen}
      toggle={handleStaySignedIn}
      title={"Session Timeout"}
      icon="exclamation-solid"
      iconColor="#FEF3C7"
      btn1={{
        text: "Keep Me Signed In",
        btnStyle: "primary",
        onClick: handleStaySignedIn,
      }}
      btn2={{
        text: "Sign Out Now",
        onClick: handleLogout,
      }}
    >
      <p>
        As a security precaution, you will be signed out in {timer} due to
        inactivity. Do you want to stay signed in?
      </p>
    </FixedModal>
  );
}

export default SessionTimeout;
